import * as yup from 'yup'
import { parseNumber } from 'libphonenumber-js'
import isEmpty from 'lodash/isEmpty'
import { REQUIRED_DATE, ERROR_INVALID_EMAIL, ERROR_INVALID_PHONE_NUMBER } from './../constants'
export default yup.object({
  dateOfOccupancy: yup.mixed().test('dateRequired', REQUIRED_DATE, val => {
    if (!val) return false

    val = new Date(val)
    return val instanceof Date && !isNaN(val)
  }),
  // .test('dateNotBeforeToday', ERROR_DATE_NOT_IN_PAST, val => {
  //   const today = moment().startOf('day')
  //   return moment.isMoment(val) ? val.isAfter(today) : moment(val).isAfter(today)
  // }),
  currentResidenceOwner: yup.object({
    email: yup.string().email(ERROR_INVALID_EMAIL),
    phone: yup.string().test('isValidPhoneNumber', ERROR_INVALID_PHONE_NUMBER, val => {
      if (val === undefined) return true
      if (val.length <= 3) return true
      return !isEmpty(parseNumber(val))
    }),
  }),
})



// WEBPACK FOOTER //
// ./src/utils/validation/schemas/rentIntentionSchema.js